import Requester from "./Requester";

interface CreateDTO {
    name: number
    parentId?: number
}

const URL = 'api/categories';

export function getCategories(limit: number = 10, page: number = 1, search: string | null = null, options) {
    const requester = new Requester();

    let requestOptions = {}

    if (options !== undefined) {
        requestOptions = {
            ...options
        }
    }

    return requester.get(requester.getUrl(URL, [
        { name: 'limit', value: limit },
        { name: 'page', value: page },
        { name: 'search', value: search },
    ]), requestOptions)
}

export function getCategory(id: number) {
    const requester = new Requester();

    return requester.get(requester.getUrl(`${URL}/${id}`))
}

export function destroy(id) {
    const requester = new Requester();

    return requester.delete(requester.getUrl(`${URL}/${id}`))
}

export function create(values: CreateDTO) {
    const requester = new Requester();

    return requester.post(requester.getUrl(URL), values)
}

export default {
    create,
    getCategories,
    getCategory,
    destroy,
}